/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=bafb1310&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bafb1310&lang=scss&scoped=true"

import exportComponent from "F:\\System\\sengi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafb1310"]])

export default __exports__